import { Component, OnInit } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { filter } from 'rxjs/operators';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-iframe',
    template: `<iframe [src]="url"></iframe>`,
    styles: [],
    standalone: false
})
export class AppiframeComponent {
  url: SafeResourceUrl;

  constructor(private router: Router, private sanitizer: DomSanitizer) {
    const navigation = router.getCurrentNavigation();
    if (navigation !== null && navigation.extras !== null && navigation.extras.state !== null && navigation.extras.state.url !== null) {
      this.url = sanitizer.bypassSecurityTrustResourceUrl(navigation.extras.state.url);
      console.log('this.url', this.url);
    }
  }
}
